import React from 'react';
import { Outlet } from 'react-router-dom';

const SellYourBusinessRouter: React.FC = () => <Outlet />;

export default SellYourBusinessRouter;
